import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { fetchWithAuth } from "@/lib/api/client";
import type { Licitacion } from "@/types/licitacion";
import { LicitacionFormWizard } from "@/components/licitaciones/licitacion-form-wizard";
import { Skeleton } from "@/components/ui/skeleton";

export default function EditarLicitacionPage() {
  const { id } = useParams<{ id: string }>();

  const { data: licitacion, isLoading } = useQuery<Licitacion>({
    queryKey: ["licitacion", id],
    queryFn: () => fetchWithAuth(`/api/v1/licitaciones/${id}`),
    enabled: !!id,
  });

  if (isLoading) {
    return (
      <div className="p-6 space-y-4">
        <Skeleton className="h-8 w-1/3" />
        <Skeleton className="h-96 w-full" />
      </div>
    );
  }

  if (!licitacion) {
    return (
      <div className="p-6 text-center py-12">
        <p className="text-red-600 font-medium">No se pudo cargar la licitación</p>
      </div>
    );
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Editar Licitación</h1>
      <LicitacionFormWizard
        licitacionId={id}
        initialData={{
          titulo: licitacion.titulo,
          referencia: licitacion.referencia || "",
          descripcion: licitacion.descripcion || "",
          organismo: licitacion.organismo,
          tipo_contrato: licitacion.tipo_contrato,
          presupuesto_base: licitacion.presupuesto_base?.toString() || "",
          valor_estimado: licitacion.valor_estimado?.toString() || "",
          fecha_publicacion: licitacion.fecha_publicacion || "",
          fecha_limite: licitacion.fecha_limite || "",
          prioridad: licitacion.prioridad,
          url_plataforma: licitacion.url_plataforma || "",
          etiquetas: licitacion.etiquetas,
          notas: licitacion.notas || "",
        }}
      />
    </div>
  );
}
